import { render, staticRenderFns } from "./UpdateAbsencePage.vue?vue&type=template&id=18990ba0&scoped=true&"
import script from "./UpdateAbsencePage.vue?vue&type=script&lang=js&"
export * from "./UpdateAbsencePage.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAbsencePage.vue?vue&type=style&index=0&id=18990ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18990ba0",
  null
  
)

export default component.exports